import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useDeleteVaccine = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (vaccine) => {
      const axiosInstance = createAxiosInstance();
      return axiosInstance.delete(`${tenantVal}/immunisation/delete`, {
        data: vaccine,
      });
    },
    onSuccess: () => {
      toast.success("Vaccine deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["settingsVaccines", tenantVal] });
    },
    onError: (error) => {
      toast.error(error.message || "An error occurred");
    },
  });
};
